import axios from 'axios';

const url = 'https://api.app-lab.be-keeper.com/posts';
// const url = `${process.env.API}/posts`;

//Posts
export const fetchPosts = () => axios.get(url);
export const fetchPostTags = (id) => axios.get(`${url}/${id}/tags`);
export const createPosts = (newPost) => axios.post(url, newPost);
export const updatePost = (id, updatedPost) => axios.patch(`${url}/${id}`, updatedPost);
export const deletePost = (id) => axios.delete(`${url}/${id}`);
